import { render, staticRenderFns } from "./create-booking.vue?vue&type=template&id=135a1af6&"
import script from "./create-booking.vue?vue&type=script&lang=js&"
export * from "./create-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports